<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <h1>Forgot Password</h1>
                <p class="text-muted">Enter the email address associated with your account</p>
                <hm-alert/>
                <b-form @submit.prevent="onSubmit">
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text>@</b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      name="email"
                      type="text"
                      class="form-control"
                      placeholder="Email"
                      aria-describedby="emailFeedback"
                      autocomplete="email"
                      v-model="email"
                      v-validate="'required|email'"
                      :disabled="!ready"
                      :class="{ 'is-invalid': errors.has('email') && submitted }"
                    />
                    <b-form-invalid-feedback id="emailFeedback">Please enter a valid email address</b-form-invalid-feedback>
                  </b-input-group>
                  <b-row>
                    <b-col cols="6">
                      <b-button variant="link" class="px-0" :disabled="!ready" to="/login">Return to login</b-button>
                    </b-col>
                    <b-col cols="6" class="text-right">
                      <b-button type="submit" variant="primary" class="px-4" :disabled="!ready">
                        <i class="fa fa-refresh fa-spin" v-if="!ready"></i>
                        Reset
                      </b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
              <b-card-footer class="p-4">
                <hm-footer-logo/>
              </b-card-footer>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { authService } from '@/services';

export default {
  name: 'ForgotPassword',
  data() {
    return {
      email: '',
      ready: true,
      submitted: false
    };
  },
  methods: {
    ...mapActions({
      alertClear: 'alert/clear',
      alertError: 'alert/error',
      alertException: 'alert/exception'
    }),
    onSubmit() {
      this.ready = false;
      this.submitted = true;
      this.alertClear();

      this.$validator.validate()
        .then(valid => {
          if (valid) {
            return authService.forgotPassword(this.email)
              .then(resp => {
                this.$gtag.event('forgot_pswd', { 'event_category': 'engagement' });
                this.$router.push({ name: 'ForgotConfirm', params: { email: this.email } });
              })
              .catch(err => {
                this.alertException({ err, message: 'Invalid email address, please try again.' });
              });
          } else {
            // this.alertError('Please complete all information and submit again.');
          }
        })
        .finally(() => {
          this.ready = true;
        });
    }
  }
}
</script>